import React from 'react'
import { ApolloClient } from 'apollo-client'
import { ApolloProvider } from 'react-apollo'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import api from '../helpers/shopify'

// Share Shopify verification and the bounded session retry with the REST APIs.
export const shopifyFetch = async (uri, options) => {
    try {
        const response = await api.post(uri, JSON.parse(options.body))
        return new Response(JSON.stringify(response.data), { status: response.status,
            headers: { 'Content-Type': 'application/json' } })
    } catch (error) {
        if (!error.response) throw error
        return new Response(JSON.stringify(error.response.data), { status: error.response.status,
            headers: { 'Content-Type': 'application/json' } })
    }
}

class GraphqlProvider extends React.Component {
    client = new ApolloClient({ link: createHttpLink({ uri: '/api/graphql', fetch: shopifyFetch }), cache: new InMemoryCache() })
    render() { return <ApolloProvider client={this.client}>{this.props.children}</ApolloProvider> }
}

export default GraphqlProvider
